import { render, staticRenderFns } from "./viewLogisticsChannel.vue?vue&type=template&id=1aa65da6&scoped=true"
import script from "./viewLogisticsChannel.vue?vue&type=script&lang=js"
export * from "./viewLogisticsChannel.vue?vue&type=script&lang=js"
import style0 from "./viewLogisticsChannel.vue?vue&type=style&index=0&id=1aa65da6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa65da6",
  null
  
)

export default component.exports